__webpack_require__.p = "https://monocle.qa.magmutual.com/";